import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Integration } from "../_types/integration";

@Injectable({
    providedIn: 'root',
})

export class IntegrationsService extends Service<Integration> {
  public override type = 'integrations';
  public override url = 'attendance/integrations';   
}
